import { useRouteError, isRouteErrorResponse, Link } from 'react-router-dom';
import styles from './ErrorPage.module.css';

export default function ErrorPage() {
    const error = useRouteError();

    const getErrorDetails = () => {
        if (isRouteErrorResponse(error)) {
            if (error.status === 404) return {
                code: '404',
                title: 'Page not found',
                message: 'The page you\'re looking for doesn\'t exist or has been moved.',
            };
            if (error.status === 401) return {
                code: '401',
                title: 'Not authorised',
                message: 'You need to be signed in to view this page.',
            };
            if (error.status === 403) return {
                code: '403',
                title: 'Access denied',
                message: 'You don\'t have permission to view this page.',
            };
            if (error.status === 500) return {
                code: '500',
                title: 'Server error',
                message: 'Something went wrong on our end. We\'re looking into it.',
            };
            return {
                code: String(error.status),
                title: error.statusText,
                message: 'Something unexpected happened.',
            };
        }
        return {
            code: 'Oops',
            title: 'Something went wrong',
            message: 'An unexpected error occurred. Please try again.',
        };
    };

    const { code, title, message } = getErrorDetails();

    return (
        <div className={styles.page}>
            <div className={styles.card}>

                <div className={styles.errorCode}>{code}</div>
                <div className={styles.rule} />
                <h1 className={styles.title}>{title}</h1>
                <p className={styles.message}>{message}</p>

                <div className={styles.actions}>
                    <Link to="/" className={styles.btnPrimary}>
                        <i className="fas fa-house" />
                        Go home
                    </Link>
                    <button className={styles.btnSecondary} onClick={() => window.history.back()}>
                        <i className="fas fa-arrow-left" />
                        Go back
                    </button>
                </div>
            </div>
        </div>
    );
}
